import React, { useState } from 'react';

import { Box, Display } from '@rover/kibble/core';
import FilterChipGroup from '@rover/kibble/patterns/chips/FilterChipGroup/FilterChipGroup';
import { emitAnalyticsEvent } from '@rover/rsdk/src/modules/Analytics';
import { RoverBrand } from '@rover/types/src/RoverBrand';

import { BrandActivationFAQCategoryClick } from '../../analyticsEvents';

import FAQContent from './components/FAQContent';
import { FAQCategory, FAQCategoryType, FAQConfig } from './types';

type Props = {
  config: FAQConfig;
  onCategoryChange?: (categoryId: string) => void;
  brand: RoverBrand;
};

const BrandFAQSection = ({ config, onCategoryChange, brand }: Props): JSX.Element => {
  const hasCategories = config.type === FAQCategoryType.TABBED;
  const [selectedContent, setSelectedContent] = useState<FAQCategory | FAQConfig | undefined>(
    hasCategories ? config.categories?.[0] : config
  );

  const handleCategoryChange = (
    newValue: Array<string | number> | (string | number) | null
  ): void => {
    const id = Array.isArray(newValue) ? newValue[0] : newValue;

    if (typeof id !== 'string' || id === (selectedContent as FAQCategory).id) return;

    const category = config.categories?.find((cat) => cat.id === id);

    if (category) {
      emitAnalyticsEvent(
        new BrandActivationFAQCategoryClick({
          brand,
          categoryId: id,
          categoryLabel: category.label,
        })
      );
    }

    setSelectedContent(category as FAQCategory);
    onCategoryChange?.((category as FAQCategory).id);
  };

  return (
    <>
      <Display size="500" mb="6x">
        {config.title}
      </Display>
      {hasCategories && !!config.categories?.length && (
        <Box pt="6x">
          <FilterChipGroup
            groupLabel={config.subtitle}
            showLabel={!!config.subtitle}
            options={config.categories.map((cat) => ({
              id: cat.id,
              label: cat.label,
              value: cat.id,
            }))}
            canSelectMultiple={false}
            isDeselectable={false}
            selectedValues={selectedContent ? [(selectedContent as FAQCategory).id] : []}
            size="small"
            onChange={handleCategoryChange}
            selectedIcon={null}
          />
        </Box>
      )}

      {selectedContent && <FAQContent content={selectedContent} />}
    </>
  );
};

export default BrandFAQSection;
